import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { GetActiveEmployeeApi } from "../employee/employeeAction";
import { setHeading } from "../../../accounts/account.actions";
import { AddFineApi } from "./FineAndPenaltyAction";
import { appendNonSignificantZeros } from "../../../../../global/globalFunctions";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import _ from "lodash";
import Select from 'react-select';
import moment from "moment";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const AddFineAndPenalty = (props) => {
    const [employeeId, setEmployeeId] = useState("");
    const [employeeName, setEmployeeName] = useState("");
    const [reason, setReason] = useState('');
    const [amountDeduct, setAmountDeduct] = useState('');
    const [date, setDate] = useState('');

    function SaveFine() {
        props.AddFineApi({
            employeeId: employeeId,
            employeeName: employeeName,
            amountDeduct: Number(amountDeduct),
            date: date,
            reasonFine: reason,
        },
            showSuccessAlert,
            showErrorAlert,
        );
        setEmployeeId("")
        setEmployeeName("")
        setReason("")
        setAmountDeduct("")
        setDate("")
    };

    const getEmployeeList = _.isEmpty(props.activeEmployeeList) ? [] : props.activeEmployeeList.map((x) => {
        let data = { value: x._id, label: `${appendNonSignificantZeros(x.employeeName)}-${x.fatherName}-${x.cnic}` };
        return data
    })
    const handleChangeEmployee = (selectedOption) => {
        setEmployeeId(selectedOption.value);
        setEmployeeName(selectedOption.label);
    };

    useEffect(() => {
        props.GetActiveEmployeeApi();
        props.setHeading("Fine & Penalties");
    }, []);

    return (
        <>
            {props.isFetchingActiveEmployeeData || props.isAddingFine ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana" >
                                <Form.Label><b>Select Employee *</b></Form.Label>
                                <Select
                                    placeholder="Select Employee"
                                    onChange={handleChangeEmployee}
                                    options={getEmployeeList}
                                    isDisabled={_.isEmpty(getEmployeeList)}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana" >
                                <Form.Label><b>Fine Amount *</b></Form.Label>
                                <Form.Control
                                    type="number"
                                    placeholder="Fine Amount"
                                    onChange={(e) => setAmountDeduct(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana" >
                                <Form.Label><b>Date *</b></Form.Label>
                                <Form.Control
                                    type="date"
                                    min={moment().subtract(1, 'months').format('YYYY-MM-DD')}
                                    max={moment().subtract(0, 'months').format('YYYY-MM-DD')}
                                    placeholder="Date"
                                    onChange={(e) => setDate(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana" >
                                <Form.Label><b>Reason *</b></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Reason"
                                    onChange={(e) => setReason(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="sendDiv">
                        {_.isEmpty(employeeId) || _.isEmpty(reason) || _.isEmpty(date) || _.isEmpty(amountDeduct) ? (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
                        ) : (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={() => { SaveFine(); }}> SAVE </Button>
                        )}
                    </div>
                </Container>
            )}
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        AddFineApi: (data, showSuccessAlert, showErrorAlert) => dispatch(AddFineApi(data, showSuccessAlert, showErrorAlert)),
        GetActiveEmployeeApi: () => dispatch(GetActiveEmployeeApi()),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isAddingFine: state.FineReducer.isAddingFine,
    activeEmployeeList: state.EmployeeReducer.activeEmployeeList,
    isFetchingActiveEmployeeData: state.EmployeeReducer.isFetchingActiveEmployeeData,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddFineAndPenalty);